import { Table } from '../../../modules/tables/types';
import { ModalRowItemValueProps } from '../../molecules/ModalRowItem';
import { CELL_CONFIG } from '../Table/constants';

export const getModalRows = (table?: Table): ModalRowItemValueProps[] => {
  if (!table) {
    return [];
  }

  const fieldNames = table.keyOrder.length ? table.keyOrder : Object.keys(table.schema);
  return fieldNames.map((fieldName, column) => {
    const { required, type } = table.schema[fieldName];
    return {
      fieldColumnItem: {
        icon: CELL_CONFIG[type].icon,
        indicator: { value: required ? '*' : '' },
        type: required ? 'Required' : 'Default',
        text: { value: fieldName },
      },
      modalFields: {
        cellColumn: column,
        type: CELL_CONFIG[type].type,
      },
    };
  });
};
